module.exports = __webpack_public_path__ + "8d2762fbe801dda77cabd5757bdb73d2.pdf";